﻿window.onload = () => {
    SetupDealPage();
};

function SetupDealPage() {
    $('#PreEnqSendToFriendDiv').InitialiseSendToFriendForm({
        openOnClickElement: $('#PreEnqSendToFriendLink'),
        onClose: OnCloseSendToFriend
    });

    if (document.querySelector("#hidVehCapId")) {
        $.get("/deal/vehiclespecifications", {
            capId: document.querySelector("#hidVehCapId").value,
            vehicleType: document.querySelector("#hidVehType").value,
            specificationDate: document.querySelector("#hidVehSpecDate").value
        }, function (data) {
            document.querySelector("#divTechSpec").innerHTML = data.TechSpecsHtml;
            document.querySelector("#divEquipment").innerHTML = data.EquipmentHtml;
            document.querySelector("#divOptions").innerHTML = data.OptionsHtml;
        });
    }

    // deal-page-spec-accordion
    document.querySelectorAll('.deal-accordion-heading').forEach(subheading => {
        subheading.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle('active');
            const nextPanel = this.nextElementSibling;
            $(nextPanel).slideToggle(90);

            // Check if the element is inside a parent with class "modal"
            const isInsideModal = this.closest('.modal') !== null;

            // Scroll opened element into view only if it's not inside a modal
            if (!isInsideModal) {
                setTimeout(() => {
                    const yOffset = -50;
                    const y = this.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }, 100);
            }
        });
    });

    document.querySelectorAll('.share-deal').forEach(function (button) {
        button.addEventListener('click', function () {
            const currentUrl = window.location.href;

            if (currentUrl.includes('#')) {
                const newUrl = currentUrl.split('#')[0];
                window.history.replaceState(null, null, newUrl);
            }
        });
    });
}

function OnCloseSendToFriend() { }

function copyLink() {
    let copyText = document.getElementById("urlInput");
    let copyButton = document.querySelector('#copy-btn');

    copyButton.disabled = true;

    navigator.clipboard.writeText(copyText.value)
        .then(() => {
            copyButton.textContent = "Copied!";
            setTimeout(() => {
                copyButton.textContent = "Copy link";
                copyButton.disabled = false;
            }, 2000);
        })
        .catch(() => {
            copyButton.textContent = "Error!";
            setTimeout(() => {
                copyButton.textContent = "Copy link";
                copyButton.disabled = false;
            }, 2000);
        });
}